<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span>For my beloved husband, William Robert Prestie, who always “answers as a man.”</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?2bca445a